export const distanceLatLng = (
  { lat: lat1, lng: lng1 }: { lat: number; lng: number },
  { lat: lat2, lng: lng2 }: { lat: number; lng: number }
): number => {
  // TODO: this is still probably wrong, but it's close
  return Math.sqrt((lat1 - lat2) ** 2 + (lng1 - lng2) ** 2);
};

export const relativeElementWithWraparound = (array: any[], element: any, difference: number, edgeBehaviour: 'loop' | 'exit' | 'nothing' = 'loop') => {
  const index = array.findIndex(e => e.id === element.id);
  const newIndex = index + difference;
  if (newIndex < 0) {
    if (edgeBehaviour === 'loop') {
      return array[array.length - 1];
    }
    if (edgeBehaviour === 'exit') {
      return null;
    }
    return element;
  }
  if (newIndex >= array.length) {
    if (edgeBehaviour === 'loop') {
      return array[0];
    }
    if (edgeBehaviour === 'exit') {
      return null;
    }
    return element;
  }
  return array[newIndex];
};

export const mergeClasses = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};

export const shortDateFormatter = (date: Date): string => {
  return new Intl.DateTimeFormat('en', {
    month: 'long',
    year: '2-digit'
  }).format(date).replace(/(\d{2})/, ' \'$1');
};

export const mediumDateFormatter = (date: Date): string => {
  return new Intl.DateTimeFormat('en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(date);
};

export const fullDateFormatter = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }).format(date);
};

export const monthYearFormatter = (date: Date): string => {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  return firstDayOfMonth.toISOString();
};
